var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73606 1.12077C7.9011 1.32706 7.98878 1.55399 7.99909 1.80154C8.0094 2.04909 7.92173 2.2657 7.73606 2.45137L2.28988 7.89756L7.76701 13.3747C7.93204 13.5397 8.0094 13.7615 7.99909 14.04C7.98878 14.3185 7.9011 14.5403 7.73606 14.7053C7.52977 14.9116 7.308 15.0096 7.07076 14.9993C6.83352 14.9889 6.62207 14.891 6.43641 14.7053L0.278499 8.54739C0.175351 8.44424 0.103148 8.34109 0.0618887 8.23794C0.0206299 8.1348 0 8.02133 0 7.89756C0 7.77378 0.0206299 7.66032 0.0618887 7.55717C0.103148 7.45402 0.175351 7.35088 0.278499 7.24773L6.40546 1.12077C6.59113 0.935101 6.80774 0.847425 7.05529 0.85774C7.30284 0.868054 7.52977 0.955729 7.73606 1.12077Z",
    fill: "#2C74D6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default "data:image/svg+xml,%3csvg width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M7.73606 1.12077C7.9011 1.32706 7.98878 1.55399 7.99909 1.80154C8.0094 2.04909 7.92173 2.2657 7.73606 2.45137L2.28988 7.89756L7.76701 13.3747C7.93204 13.5397 8.0094 13.7615 7.99909 14.04C7.98878 14.3185 7.9011 14.5403 7.73606 14.7053C7.52977 14.9116 7.308 15.0096 7.07076 14.9993C6.83352 14.9889 6.62207 14.891 6.43641 14.7053L0.278499 8.54739C0.175351 8.44424 0.103148 8.34109 0.0618887 8.23794C0.0206299 8.1348 0 8.02133 0 7.89756C0 7.77378 0.0206299 7.66032 0.0618887 7.55717C0.103148 7.45402 0.175351 7.35088 0.278499 7.24773L6.40546 1.12077C6.59113 0.935101 6.80774 0.847425 7.05529 0.85774C7.30284 0.868054 7.52977 0.955729 7.73606 1.12077Z' fill='%232C74D6'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };